import { apiService } from "./../../app.service";

export const accountApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    cancelSubscription: builder.mutation({
      query: () => ({
        url: "/auth/subscription/cancel",
        method: "POST",
      }),
      invalidatesTags: ["Me"],
    }),
    resumeSubscription: builder.mutation({
      query: () => ({
        url: "/auth/subscription/resume",
        method: "POST",
      }),
      invalidatesTags: ["Me"],
    }),
    resubscribeSubscription: builder.mutation({
      query: () => ({
        url: "/auth/subscription/resubscribe",
        method: "POST",
      }),
    }),
    updatePaymentMethod: builder.mutation({
      query: (data) => ({
        url: "/auth/payment-method",
        method: "POST",
        body: data,
      }),
    }),
    updatePassword: builder.mutation({
      query: (data) => ({
        url: "/auth/password",
        method: "PUT",
        body: data,
      }),
    }),
    updateProfile: builder.mutation({
      query: (data) => ({
        url: "/auth/profile",
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useCancelSubscriptionMutation,
  useResumeSubscriptionMutation,
  useResubscribeSubscriptionMutation,
  useUpdatePaymentMethodMutation,
  useUpdatePasswordMutation,
  useUpdateProfileMutation,
} = accountApi;
